import { ArrowDownward, ArrowUpward } from "@material-ui/icons";
import React from "react";
import './featuredInfo.css'

const FeaturedInfo = () => {
  return (
    <div className="featured">
      <div className="featured_item">
        <span className="featured_title">Revanue</span>
        <div className="featured_money_container">
          <span className="featured_money">$12</span>
          <span className="featured_money_rate">
            -11.3 <ArrowDownward className="featured_icon negative"/>
          </span>
        </div>
        <span className="featured_sub">Compared to last month</span>
      </div>
      <div className="featured_item">
        <span className="featured_title">Revanue</span>
        <div className="featured_money_container">
          <span className="featured_money">$12</span>
          <span className="featured_money_rate">
            +11.3 <ArrowUpward className="featured_icon"/>
          </span>
        </div>
        <span className="featured_sub">Compared to last month</span>
      </div>
      <div className="featured_item">
        <span className="featured_title">Revanue</span>
        <div className="featured_money_container">
          <span className="featured_money">$12</span>
          <span className="featured_money_rate">
            -11.3 <ArrowDownward className="featured_icon negative"/>
          </span>
        </div>
        <span className="featured_sub">Compared to last month</span>
      </div>
    </div>
  );
};

export default FeaturedInfo;
